import React, { useMemo, useCallback } from 'react'
import { Template } from 'devextreme-react/core/template'
import { exportDataGrid } from 'devextreme/excel_exporter'
import excelJS from 'exceljs'
import saveAs from 'file-saver'
import { useTranslation } from 'react-i18next'

import ItemActions from 'components/SectionHandler/ItemActions'
import { Export as ExportIco } from 'media/icons'

export default props => {
	const { withSearch, excelExport, excelExportUngrouped, ref, toolBarActions = [] } = props
	const [t] = useTranslation()

	const templates = Array.isArray(props.templates) ? [...props.templates] : []
	const renderActions = useMemo(() => !!excelExport || !!toolBarActions.length, [excelExport, toolBarActions.length])
	const onToolbarPreparing = e => {
		if(props.onToolbarPreparing) {
			props.onToolbarPreparing(e)
		}
		if(withSearch) {
			e.toolbarOptions.items.unshift({
				location: 'before',
				template: 'search'
			})
		}
		if(renderActions) {
			e.toolbarOptions.items.push({
				location: 'after',
				template: 'actions'
			})
		}
	}

	const handleExport = ({ isUngrouped = false } = {}) => e => {
		const dataGrid = ref.current.instance;
		const workbook = new excelJS.Workbook()
		const worksheet = workbook.addWorksheet('Sheet 1')

		const originalState = dataGrid.state()
		if(isUngrouped) {
			dataGrid.clearGrouping()
		}

		// Use a small delay or check for content readiness
		// DevExtreme export reads from the current visual state
		setTimeout(() => {
			exportDataGrid({
				component: dataGrid,
				worksheet: worksheet,
				autoFilterEnabled: true
			}).then(() => {
				workbook.xlsx.writeBuffer().then(buffer => {
					saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx')
					if(isUngrouped) {
						dataGrid.state(originalState)
					}
				})
			})
		}, 100)
		e.cancel = true
	}

	const searchRender = useCallback(() => (
		<input
			type='text'
			onChange={e => {
				const val = e.target.value
				ref.current.instance.searchByText(val)
			}}
			placeholder={t('common.strings.search')}
		/>
	), [ref])
	const actionsRender = () => {
		const actions = [...toolBarActions]
		if(excelExport) {
			actions.push({
				label: t('common.strings.excel_export'),
				action: handleExport(),
				Icon: ExportIco
			})
		}
		if(excelExportUngrouped) {
			actions.push({
				label: t('common.strings.excel_export_ungrouped'),
				action: handleExport({ isUngrouped: true }),
				Icon: ExportIco
			})
		}
		return actions.length ? <ItemActions actions={actions} /> : null
	}

	if(withSearch) {
		templates.push(<Template key='search' name='search' render={searchRender} />)
	}
	if(renderActions) {
		templates.push(<Template key='actions' name='actions' render={actionsRender} />)
	}

	return {
		onToolbarPreparing,
		templates
	}
}
